export const STATUS_ACTIVE = 'active';
export const STATUS_INACTIVE = 'inactive';
export const STATUS_SUSPENDED = 'suspended';
export const STATUS_NA = 'na';
